import OrderDetailsActions from 'components/order-details/order-details-actions';
import OrderDetailsTabs from 'components/order-details/order-details-tabs';
import OrderSummary from 'components/order-details/order-summary';
import { reactiveFeedbackMessage } from 'core/apollo-cache';
import { OrderDetailsProvider, useOrderDetails } from 'hooks/orderDetails';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';

export type OrderLineItem = {
  amount: number;
  canceled: boolean;
  description: string;
  externalType: string;
  id: number;
  participantGroupName: string;
  participantName: string;
  type: string;
  name?: string;
};

export type Order = {
  id: number;
  orderNumber: string;
  status: string;
  customerEmail: string;
  amount: number;
  amountPaid: number;
  amountRemaining: number;
  amountRefunded: number;
  lineItems: OrderLineItem[];
};

export enum OrderDetailsTab {
  FEES,
  NOTES,
}

const OrderDetailsPage = ({
  orgId,
  orderId,
}: {
  orgId: string;
  orderId: string;
}) => {
  const { error } = useOrderDetails(+orgId, orderId);

  React.useEffect(() => {
    // There's currently a bug where if we use toast here, toasts from child
    // components won't show up the first time, then will show up after. Once
    // this bug is fixed, we can use toast here too
    if (error) {
      reactiveFeedbackMessage({
        isError: true,
        message: error,
        autoclose: true,
      });
    }
  }, [error]);

  return (
    <div id="order-details" className="container hub-full-width">
      <div
        className="page-content u-xs-padXl u-flexExpandSides"
        data-testid="order-details--container"
      >
        <div className="page-content-header Grid u-flexAlignItemsCenter">
          <div className="Grid-cell u-xs-size1of2">
            <h1 data-testid="order-details--header">Order {orderId}</h1>
          </div>

          <OrderDetailsActions />
        </div>

        <OrderSummary mods="u-spaceBottomLg" />

        <div
          className="page-content-body u-padBottomXxl"
          data-testid="order-detail--tabs"
        >
          <OrderDetailsTabs />
        </div>
      </div>
    </div>
  );
};

const OrderDetails = ({
  match: {
    params: { orgId, orderId },
  },
}: RouteComponentProps<{ orgId: string; orderId: string }>) => (
  <OrderDetailsProvider>
    <OrderDetailsPage orgId={orgId} orderId={orderId} />
  </OrderDetailsProvider>
);

export default OrderDetails;
